import { stepConfigItem } from './types';

const stepsSchemaEn: stepConfigItem[] = [
  {
    id: 'dietType',
    slug: 'diet-type',
  },
  { id: 'summary', slug: 'summary' },
];

export default stepsSchemaEn;
